export default __webpack_public_path__ + "static/media/looser-image.e4ad5b0a.png";